import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { hideLoader, showLoader } from '../../loader';
import { apiUrl } from '../../../utils/url';
import { createFormdataValues } from '../../../utils/createFormdataValues';
import { audiencePosts } from '../../../services/postRequests/audience';
import { NavLink } from 'react-bootstrap';
import ExportHistory from './export-history';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import DynamicModal from '../../../pages/dynamic-modal';
import ExportToModal from '../product-settings/product-tabs/exports/export-to-modal';
import ExportFormModal from '../product-settings/product-tabs/exports/export-form-modals';
const parseCSV = (csvText) => {
  const rows = [];
  let currentRow = [];
  let insideQuotes = false;
  let currentField = '';

  for (let i = 0; i < csvText.length; i++) {
    const char = csvText[i];

    if (char === '"') {
      insideQuotes = !insideQuotes;
    }

    if (char === ',' && !insideQuotes) {
      currentRow.push(currentField.trim());
      currentField = '';
    } else if ((char === '\n' || char === '\r') && !insideQuotes) {
      if (currentField !== '') {
        currentRow.push(currentField.trim());
      }
      if (currentRow.length > 0) {
        rows.push(currentRow);
        currentRow = [];
      }
      currentField = '';
    } else {
      currentField += char;
    }
  }

  // Add last row if not empty
  if (currentField !== '' || currentRow.length > 0) {
    if (currentField !== '') {
      currentRow.push(currentField.trim());
    }
    if (currentRow.length > 0) {
      rows.push(currentRow);
    }
  }

  return rows;
};
const detectDelimiter = (csvText) => {
  const delimiters = [',', ';', '\t', '|'];
  for (let delimiter of delimiters) {
    const rows = csvText.split(/\r?\n/).filter(row => row.trim() !== '');
    if (rows.length > 0) {
      const colCount = rows[0].split(delimiter).length;
      if (colCount > 1 && rows.every(row => row.split(delimiter).length === colCount)) {
        return delimiter;
      }
    }
  }
  return ','; // Default to comma if no delimiter found
}
const Generate = (props) => {
  let params = []
  const { campaign_id } = props;
  const history = useHistory();
  const [importType, setImportType] = useState("csv");
  const [uploadedFile, setUploadedFile] = useState(null);
  const dispatch = useDispatch();
  const { slug, basePath } = useSelector(state => state?.slugReducer);
  const refUpload = useRef(null);
  const [csvColumns, setCsvColumns] = useState([]);
  const [mappedData, setMappedData] = useState([]);
  const [manualData, setManualData] = useState({});
  const variablesMain = useSelector(state => state?.variablesReducer);
  const [variables,setVariables] = useState(variablesMain?.slice(4))
  const [newVariable, setNewVariable] = useState();
  const [stepToShow, setStepToShow] = useState(1);
  const creditsDataReducer = useSelector(state => state?.creditsDataReducer)
  const [formValues, setformValues] = useState({
    subscriber_name_index: "0", subscriber_email_index: "0", subscriber_company_name_index: "0", csv_file: null,download_csv:true,
  })
  const [error, setError] = useState([])
  const [showProcessingText, setShowProcessingText] = useState(false);
  const [rowsData, setRowsData] = useState({ duplicate: 0, total_pages: 0, unique_pages: 0 });
  const [isGenerateDisabled, setIsGenerateDisabled] = useState(true)
  const [duplicate, setDuplicate] = useState('remove_duplicate')
  const [exportHistory, setExportHistory] = useState([]);
  const [leads, setLeads] = useState([{ name: '', email: '', company_name: '', variables: [] }]);
  const [filter, setfilter] = useState({
    page: 1,
    orderBy: null,
    filter: null,
    orderType: "asc",
    count: localStorage?.leads_count ?? 10
  })
  const [loading, setloading] = useState(true);
  const [exportToSteps, setExportToSteps] = useState({step:0});
  const csvStepsArray = [
    { no: 1, name: "Upload leads" },
    { no: 2, name: "Map columns" },
    { no: 3, name: "Remove duplicates" },
    { no: 4, name: "Generate" },
  ];
  const manualStepsArray = [
    { no: 1, name: "Upload leads" },
    { no: 2, name: "Remove duplicates" },
    { no: 3, name: "Generate" },
  ];
  const [stepsArray, setStepsArray] = useState(csvStepsArray);
  const toggleImportType = (type) => {
    if (stepsArray == 'manual') {
      setStepsArray(manualStepsArray)
    }else {
      setStepsArray(csvStepsArray)
    }
    setImportType(type);
  };

  const dropzoneWrapperClick = () => {
    refUpload.current?.click();
  }
  const handleChange = (e) => {
    setUploadedFile(e.target.files)
    uploadCSV(e)
  };
  const uploadCSV = (e) => {
    e.preventDefault();
    mappingFile(e.target.files)
  }
  const mappingFile = (files) => {
    showLoader();
    setError([])
    setMappedData([]);
    if (files?.length > 0) {

      var file = files[0];
      var reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function (event) {
        var csv = event.target.result;
        const delimiter = detectDelimiter(csv);
        var data = csv.split(/\r?\n/).filter(row => row.trim() !== '');
        const csv_cols = data[0].split(delimiter).map(col => col.trim());
        if (csv_cols.length < 3) { 
          setUploadedFile(null);
          toast.error("Please upload a CSV file with at least three columns: Name, Email, and Company Name");
          hideLoader();
          return;
        }
        setCsvColumns(csv_cols);
        setformValues({
          ...formValues, csv_file: files[0],
          delimiter:delimiter

        })
        hideLoader();

        // setTimeout(() => {
        //   hideLoader()
        //   setmappingFieldModal(true)
        //   setShowExportModal(false);
        // }, 300);
      }
    }
    else {
      toast.error("Please upload a csv file")
      hideLoader()
    }
  }
  const saveMapData = () => {
    const requiredFields = ['lead_first_name', 'company_name', 'email'];
    const selectedValues = mappedData.map(item => item.selectedValue);
    const hasAllRequiredFields = requiredFields.every(field => selectedValues.includes(field));

    if (!hasAllRequiredFields) {
      toast.error('Please select lead_first_name, company_name, and email before continuing.');
      return;
    }
    // setMappedData(mappedDataArray);
    duplicateCheck('csv');
  };
  const duplicateCheck = (type) => {
    showLoader();
    const api = apiUrl + "/community/subscribers/duplicate-check";
    const formdata = createFormdataValues(formValues);
    formdata.append("project", slug)
    formdata.append("campaign", campaign_id)
    formdata.append("type", type)
    if (type == 'csv') {
      formdata.append("csvData", JSON.stringify(mappedData))
    }else {
      leads.map((val, key) => {
        if (val) {
          formdata.append(`leads[${key}][name]`, val.name);
          formdata.append(`leads[${key}][email]`, val.email);
          formdata.append(`leads[${key}][company_name]`, val.company_name);
          
          Object.entries(val.variables).forEach(([variableKey, variableValue]) => {
            formdata.append(`leads[${key}][variables][${variableKey}]`, variableValue);
          });
        }
      });
    }
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
    const setOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata
    }
    audiencePosts(api, hideLoader, setOptions, "leads").then((response) => {
      // setShow(false)
      if (response?.status_code == 200) {
        setDuplicate('remove_duplicate')
        setRowsData({ duplicate: response?.data?.duplicate_count, total_pages: response?.data?.total_rows, unique_pages: response?.data?.unique_rows, leads_limit: response?.data?.leads_limit })
        // setsubscribersLength(response?.data?.unique_rows);
        setIsGenerateDisabled(response?.data?.unique_rows > 0 && response?.data?.unique_rows <= creditsDataReducer?.total_credits ? false : true)
        if (importType == 'csv') { 
          setStepToShow(stepToShow + 1);
        }else{
          setStepToShow(3);
        }
        // setmappingFieldModal(false);
        // setShowExportModal(true);
      } else {
        if (response?.errors?.csv_file?.length > 0) {
          errorList.push(response?.errors?.csv_file);
          setError(errorList);
        } else {
          setError(Object.values(response?.errors));
          if (Object.keys(response?.errors).length > 0)
            $(".modal-body").scrollTop(0);
        }
        toast?.error(response?.status_message)
        hideLoader();
      }
    }).catch((err) => {
      toast.error(err)
    })
  };
  const continueBtn = () => {
    const newStep = stepToShow + 1;
    if (newStep == 2 && importType == 'manual') {
      if (!validateLeads()) {
        return;
      }
      duplicateCheck('manual');
      return;
    }
    if (newStep == 3) {
      saveMapData();
    // } else if (newStep == 5) {
    //   if (!isGenerateDisabled) {
    //     exportCSV()
    //   }
    } else if (newStep == 6) {
      if (!isGenerateDisabled) {
        setUploadedFile(null);
        setLeads([{ name: '', email: '', company_name: '', variables: variables }]);
        // setImportType('csv');
        setStepToShow(1);
        return
      }
    }else {
      setStepToShow(newStep);
    }
  };
  const handleAddVariable = () => {
    // Append the new variable to your array
    if (newVariable && newVariable?.trim() && !variablesMain.includes(newVariable)) {
      showLoader();
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
      var formdata = new FormData();
      formdata.append("project", slug)
      formdata.append("new_variable", newVariable)
      const api = apiUrl + '/project/add-variable';
      const setOptions = {
        headers: myHeaders,
        body: formdata,
        method: 'POST'
      }
      fetch(api, setOptions).then(async (res) => {
        const response = await res.json();
        if (response?.status_code == 200) {
          dispatch({ type: "SET_VARIABLES", payload: [...variablesMain, newVariable] })
          setNewVariable('');
          setLeads((prevLeads) => {
            const updatedLeads = prevLeads.map((lead) => {
              const updatedVariables = [...lead.variables, newVariable];
              return { ...lead, variables: updatedVariables };
            });
            return updatedLeads;
          });
          setVariables([...variables, newVariable]);
          toast.success(response?.status_message);
          hideLoader();
        } else {
          setError(Object.values(response?.errors));
          toast?.error(response?.status_message)
          hideLoader();
        }
      }).catch((error) => {
        toast?.error(error)
        hideLoader()

      })
    } else {
      toast.error("Please add a valid variable");
    }
  };
  const handleSelectValue = (index, selectedValue) => {
    if (selectedValue !== 'ignore' && mappedData.some(item => item?.selectedValue === selectedValue)) {
      return;
    }
    const updatedMappedData = [...mappedData];
    for (let i = 0; i <= index; i++) {
      if (!updatedMappedData[i]) {
        updatedMappedData[i] = { column: csvColumns[i], selectedValue: 'ignore' };
      }
    }
    updatedMappedData[index] = { column: csvColumns[index], selectedValue };
    setMappedData(updatedMappedData);
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (checked) {
      setIsGenerateDisabled(rowsData?.unique_pages > 0 && rowsData?.unique_pages <= creditsDataReducer?.total_credits ? false : true)
    } else {
      setIsGenerateDisabled(rowsData?.total_pages > 0 && rowsData?.total_pages <= creditsDataReducer?.total_credits ? false : true)
    }
    setformValues(prevData => ({
      ...prevData,
      [name]: checked,
    }));
  };
  const exportCSV = (is_exported) => {
    if (!isGenerateDisabled || (is_exported == 0 && isGenerateDisabled)) {
      showLoader();
      const api = apiUrl + "/community/subscribers/export";
      const formdata = createFormdataValues(formValues);
      formdata.append("project", slug)
      formdata.append("campaign", campaign_id)
      if (duplicate == 'remove_duplicate') {
        formdata.append("remove_duplicate", true);
      }
      formdata.append("is_exported",is_exported);
      // else {
      //   formdata.append("remove_duplicate", false);
      // }
      if (importType == 'manual') {
        leads.map((val, key) => {
          if (val) {
            formdata.append(`leads[${key}][name]`, val.name);
            formdata.append(`leads[${key}][email]`, val.email);
            formdata.append(`leads[${key}][company_name]`, val.company_name);
            
            Object.entries(val.variables).forEach(([variableKey, variableValue]) => {
              formdata.append(`leads[${key}][variables][${variableKey}]`, variableValue);
            });
          }
        });
        formdata.append("from", 'manually')
        // formdata.append("manualData", JSON.stringify(manualData))
      } else {
        if(exportToSteps?.type !== 'export_csv'){
            for (const key in exportToSteps) {
              if (Object.hasOwnProperty.call(exportToSteps, key)) {
                  if (exportToSteps[key])
                    formdata.append(key, exportToSteps[key])
              }
          };
        }
        formdata.append("csvData", JSON.stringify(mappedData))
      }
      for (const key in rowsData) {
        if (Object.hasOwnProperty.call(rowsData, key)) {
          if (rowsData[key] !== null && rowsData[key] !== undefined) {
            formdata.append(key, rowsData[key])
          }
        }
      };
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
      const setOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata
      }
      audiencePosts(api, hideLoader, setOptions, "leads").then((response) => {
        // setShow(false)
        if (response?.status_code == 200) {
          setExportToSteps(null);
          dispatch({
            type: "SET_CREDITS_DATA", payload: {
              ...creditsDataReducer,
              total_credits: response?.data?.total_credits,
              used_credits_percentage: response?.data?.used_credits_percentage,
            }
          });
        setStepToShow(stepToShow + 1);
          // history.push(response?.data?.redirect_url)
          if (importType == 'manual' && formValues?.download_csv && is_exported == 1) {
            window.open(response?.data?.redirect_url, '_blank').focus();
          } else {
            // getExportHistory();
            setShowProcessingText(true);
          }
          const currentPath = history.location.pathname; // current URL le rahe hain
          const newPath = currentPath.replace(/generate$/, "leads");
          history.push(newPath);
        }
      }).catch((err) => {
        toast.error(err)
      })
    }else {
      toast.error("Insufficient Credits");
    }
  }
  const backStep = () => {
    const previousStep = stepToShow - 1;
    if (stepToShow == 2) {
      setMappedData([]);
      setCsvColumns([]);
      setRowsData([]);
      setDuplicate('remove_duplicate');
    } else if (stepToShow == 3) {
      setDuplicate('remove_duplicate');
      if (importType == 'manual') {
        setStepToShow(1);
        return
      }
    } else if (stepToShow == 1) {
      setUploadedFile(null);
      setStepToShow(1);
      return

    }
    setStepToShow(previousStep);
  };
  const handleManuallyChange = (e, index) => {
    const { name, value } = e.target;
    setLeads((prevLeads) => {
      const updatedLeads = [...prevLeads];
      updatedLeads[index] = { ...updatedLeads[index], [name]: value };
      return updatedLeads;
    });
  };
  const validateLeads = () => {
    for (let i = 0; i < leads.length; i++) {
      const lead = leads[i];
  
      if (!lead.name) {
        toast.error(`Please enter a name for each lead.`);
        return false;
      }
      if (!lead.company_name) {
        toast.error(`Please enter a company name for each lead.`);
        return false;
      }
      if (!lead.email) {
        toast.error(`Please enter a valid email address for each lead.`);
        return false;
      }
  
      if (lead.email) {
        // Validate email format
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(lead.email)) {
          toast.error(`Please enter a valid email address for lead ${i + 1}`);
          return false;
        }
      }
    }
  
    return true;
  };
  const getExportHistory = () => {
    if (campaign_id) {
      showLoader();
      const api = `${apiUrl}/export-history/get/${slug}/${campaign_id}?${params.join("&")}`;
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
      const setOptions = {
        method: "GET",
        headers: myHeaders,
      };
      fetch(api, setOptions)
        .then(async (res) => {
          const response = await res?.json();
          if (response?.status_code == 200) {
            setExportHistory(response?.data);
            setloading(false);
          }
          hideLoader();
        }).catch(() => {
          hideLoader();
        });
    }
  };
  useEffect(() => {
    params = [];
    if (slug) {
      for (const key in filter) {
        if (Object.hasOwnProperty.call(filter, key)) {
          if (filter[key])
            params.push(`${[key]}=${filter[key]}`)
        }
      };
      if (filter?.page) getExportHistory()
    }
  }, [slug, campaign_id, filter]);
  const changeDuplicate = (val) => {
    if (val == 'remove_duplicate') {
      setIsGenerateDisabled(rowsData?.unique_pages > 0 && rowsData?.unique_pages <= creditsDataReducer?.total_credits ? false : true)
    }else {
      setIsGenerateDisabled(rowsData?.total_pages > 0 && rowsData?.total_pages <= creditsDataReducer?.total_credits ? false : true)
      
    }
    setDuplicate(val);
    
  };
  const handleDeleteLead = (index) => {
    const updatedLeads = leads.filter((_, leadIndex) => leadIndex !== index);
    setLeads(updatedLeads);
  };
  const handleDuplicateLead = (index) => {
    const newLead = { ...leads[index] }; // Clone the lead
    setLeads([...leads, newLead]);
    scrollToBottom();
  };
  const handleAddLead = () => {
    setLeads([...leads, { name: '', email: '', company_name: '', variables: [] }]);
    scrollToBottom();
  };
  const handleManuallyVariableChange = (e, index) => {
    const { value, name } = e.target;
    
    setLeads((prevLeads) => {
      return prevLeads.map((lead, i) => {
        if (i === index) {
          return {
            ...lead,
            variables: {
              ...lead.variables,
              [name]: value !== null && value !== "" ? value : null
            }
          };
        }
        return lead;
      });
    });
  };
  const scrollToBottom = () => {
    return;
    const container = document.querySelector('.scroll-on-hover');
    container.scrollTo({
      top: container.scrollHeight,
      behavior: 'smooth'
    });
  };
  const handleInputChange = (e) => {
    const { name, type, checked, value } = e.target;
    const inputValue = type === "checkbox" ? checked : value;
    setformValues({ ...formValues, [name]: inputValue });
  };
  const handleButtonClick = (e) => {
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'LABEL') {
      return;
    }
    exportCSV(1);
  };
  return (
    <section class="community-section campaign-community-section pb-0">
      <span className='generate-page-heading'>Import Leads</span>
      <div class="section-header sec-head-u mt-4">
        <div className="form-group w-100 p-0">
          {
            stepToShow  == 1 &&
            <div class="generate-toggle toggle-input-checkbox">
              <input type="radio" id="text_align_left" name="importType" defaultChecked style={{ display: "none" }} value="csv" onChange={() => toggleImportType("csv")} />
              <label for="text_align_left" className='w-50' >Upload CSV</label>
              <input type="radio" id="text_align_right" name="importType" style={{ display: "none" }} value="manual" onChange={() => toggleImportType("manual")} />
              <label for="text_align_right" className='w-50'  > Enter Manually</label>
            </div>
          }
        </div>
        <div className='disclaimer-cont'>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M6 4V6M6 8H6.005M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z" stroke="#183C81" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Upload a CSV file or enter your leads manually to add them to your campaign
        </div>
      </div>
      <div className='generate-main'>
        <div className="walkthrough-steps-main">
          {
            stepsArray?.map((val, index) => (
              <>
                <div key={index} className={`walkthrough-steps ${stepToShow == val?.no && 'active'}`}>
                  <div className="steps-no">{val?.no}</div>
                  <div className="steps-name">{val?.name}</div>
                </div>
                {index !== stepsArray.length - 1 && (
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="7" viewBox="0 0 4 7" fill="none">
                      <path d="M0.5 6.49994L3.5 3.49994L0.5 0.499939" stroke="#ADADAD" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                )}
              </>
            ))
          }
        </div>
        <div className="upload-csv generate-upload-csv">
          {stepToShow == 1 ?
            (importType == 'csv' ? (!uploadedFile ?
              <>
                <div className="text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
                    <path d="M7 14.5L11 10.5M11 10.5L15 14.5M11 10.5V19.5M19 15.2428C20.2215 14.234 21 12.7079 21 11C21 7.96243 18.5376 5.5 15.5 5.5C15.2815 5.5 15.0771 5.386 14.9661 5.19774C13.6621 2.98484 11.2544 1.5 8.5 1.5C4.35786 1.5 1 4.85786 1 9C1 11.0661 1.83545 12.9371 3.18695 14.2935" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <div>
                    Drop a file or click to browse
                  </div>
                </div>
                <input type="file" class="hidden-file-upload" name="csv_file" ref={refUpload} accept=".csv" onChange={handleChange} />
                <button onClick={dropzoneWrapperClick} type="button" class="project-upload-button">
                  Upload a .CSV file
                </button>
              </>
              :
              <>
                <small>{uploadedFile[0]?.name}</small>
              </>)
              :
              <div className='manual-leads-container'>
                <div className='overflow-auto w-100 scroll-on-hover d-flex align-items-center  pb-2'>
                  <div className='manual-lead-main'>
                    {leads.map((lead, index) => (
                      <div key={index} className="csv-col-map-main hidden-scroll">
                        <div className="lead-actions">
                          {leads.length > 1 && (
                            <button className='btn delete-btn btn-sm' onClick={() => handleDeleteLead(index)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </button>
                          )}
                          <button className='btn duplicate-btn btn-sm' onClick={() => handleDuplicateLead(index)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </button>

                        </div>
                        <div className='manual-lead-map'>
                          <input
                            type="text"
                            className="zaapGlobal-input"
                            onChange={(e) => handleManuallyChange(e, index)} // Pass index here
                            name="name"
                            placeholder="Lead Name"
                            value={lead.name} // Access the specific lead's name
                          />
                          <input
                            type="email"
                            className="zaapGlobal-input"
                            onChange={(e) => handleManuallyChange(e, index)} // Pass index here
                            name="email"
                            placeholder="Lead Email"
                            value={lead.email} // Access the specific lead's email
                          />
                          <input
                            type="text"
                            className="zaapGlobal-input"
                            onChange={(e) => handleManuallyChange(e, index)} // Pass index here
                            name="company_name"
                            placeholder="Company Name"
                            value={lead.company_name} // Access the specific lead's company name
                          />

                          {variablesMain?.slice(4).map((val, varIndex) => (
                            <input
                              key={varIndex}
                              type="text"
                              className="zaapGlobal-input"
                              onChange={(e) => handleManuallyVariableChange(e, index)} // Pass index and variable name
                              name={val}
                              placeholder={val}
                              value={lead.variables[val] || ''} // Access the specific variable value for this lead
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <button type="button" className="add-lead-btn project-blue-btn" onClick={handleAddLead}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span>Add New Lead</span>
                </button>
                <div className='manual-btns-container'>
                  <div className="d-flex align-items-center zaapGlobal-input ps-2 p-0 w-auto">
                    <input
                      type="text"
                      value={newVariable}
                      onChange={(e) => setNewVariable(e.target.value)}
                      placeholder="Add new variable"
                    />
                    <button type="button" className="project-blue-btn" onClick={handleAddVariable}>
                      Add
                    </button>
                  </div>
                </div>
              </div>
            )
            : stepToShow == 2 ?
              (
                <div className='csv-col-map-main'>
                  <div className="csv-col-map overflow-auto  hidden-scroll ">
                    <span className='csv-col-heading'>{csvColumns?.length} CSV columns to map</span>
                    <div className="csv-col-map-fields mt-20px">
                      <span className="w-50 text-left">CSV Fields:</span>
                      <span className="ms-1">Variable:</span>
                    </div>
                    {
                      csvColumns?.map((value, index) => (
                        <div className="csv-col-map-fields">
                          <span class="zaapGlobal-input">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                              <rect y="0.5" width="15" height="15" rx="3" fill="#0DCB64" />
                              <path d="M4 8H11M7.5 4.5V11.5M5.86667 4.5H9.13333C9.78673 4.5 10.1134 4.5 10.363 4.62716C10.5825 4.73901 10.761 4.91749 10.8728 5.13701C11 5.38657 11 5.71327 11 6.36667V9.63333C11 10.2867 11 10.6134 10.8728 10.863C10.761 11.0825 10.5825 11.261 10.363 11.3728C10.1134 11.5 9.78673 11.5 9.13333 11.5H5.86667C5.21327 11.5 4.88657 11.5 4.63701 11.3728C4.41749 11.261 4.23901 11.0825 4.12716 10.863C4 10.6134 4 10.2867 4 9.63333V6.36667C4 5.71327 4 5.38657 4.12716 5.13701C4.23901 4.91749 4.41749 4.73901 4.63701 4.62716C4.88657 4.5 5.21327 4.5 5.86667 4.5Z" stroke="#FAFAFA" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            {value}
                          </span>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none">
                              <path d="M0.5 4H9.5M9.5 4L6.104 1M9.5 4L6.104 7" stroke="#666666" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </span>
                          <div class="cursor-pointer table-action-dropdown d-flex justify-content-between gap-2 zaapGlobal-input dropdown-toggle noselect d-flex align-items-center dropdown-subscribers" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                            <span className="d-flex gap-2 align-items-center ">
                              {mappedData[index]?.selectedValue && mappedData[index]?.selectedValue !== 'ignore' ?
                                <span className="box-18f"></span> :
                                <span className="small-box bg-danger"></span>
                              }
                              <span className="me-5">
                                {mappedData[index]?.selectedValue || 'ignore'}
                              </span>
                            </span>
                          </div>
                          <ul class="dropdown-menu project-dropdown-menu custom-scrollbar" aria-labelledby="table-action-dropdown">
                            <li>
                              <a class={`input-with-btn dropdown-item variable-dropdown-item`} >
                                  <input type="text" id="myinput" name="myinput" className="tag-input-u"  value={newVariable} onChange={(e) => setNewVariable(e.target.value)} placeholder="Add new variable" />
                                  <button  id="addTagButton" onClick={handleAddVariable} className="tagadd-btn">Add</button>
                              </a>
                            </li>
                            {variablesMain?.length > 0 && (
                              variablesMain.sort((a, b) => (a === 'ignore' ? -1 : b === 'ignore' ? 1 : 0))
                              .map((val, idx) => (
                                <li key={idx} onClick={() => handleSelectValue(index, val)}>
                                  <a class={`dropdown-item variable-dropdown-item cursor-pointer d-flex align-items-center justify-content-between ${val !== 'ignore' && mappedData.some(item => item?.selectedValue == val) ? 'disabled' : ''}`} >
                                    <div className='d-flex align-items-center gap-1'>
                                      {val == 'ignore' ?
                                        <span class="small-box bg-danger"></span>
                                        :
                                        null
                                      }
                                      <span className="me-5">{val} </span>
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                                      <path d="M0.339129 1.24778C0.7913 0.871025 1.52442 0.871025 1.97659 1.24778L5.66087 4.31756C6.11304 4.69431 6.11304 5.30515 5.66087 5.6819C5.2087 6.05865 4.47558 6.05865 4.02341 5.6819L0.339129 2.61212C-0.113043 2.23537 -0.113043 1.62453 0.339129 1.24778Z" fill="#333333" />
                                      <path d="M5.66087 4.31756C6.11304 4.69431 6.11304 5.30515 5.66087 5.6819L1.97715 8.75161C1.52498 9.12837 0.791862 9.12837 0.339691 8.75161C-0.112481 8.37486 -0.112481 7.76402 0.339691 7.38727L4.02397 4.31749C4.47615 3.94074 5.2087 3.9408 5.66087 4.31756Z" fill="#333333" />
                                    </svg>
                                  </a>
                                  {
                                    val == 'ignore' &&
                                    <div className='section-divider my-1'></div>
                                  }
                                </li>
                              ))
                            )}
                          </ul>
                        </div>
                      ))
                    }
                  </div>
                  {/* <div className="d-flex align-items-center zaapGlobal-input ps-2 p-0 w-auto" >
                    <input type="text" value={newVariable} onChange={(e) => setNewVariable(e.target.value)} placeholder="Add new variable" />
                    <button type="button" className="project-blue-btn" onClick={handleAddVariable}>Add</button>
                  </div> */}
                </div>
              )
              : stepToShow == 3 ?
                (
                  <div className='duplicate-cont'>
                    <div>{rowsData?.duplicate} Duplicate Records Found</div>
                    <div className={`remove-duplicate ${duplicate == 'remove_duplicate' && 'active'}`} onClick={() => changeDuplicate('remove_duplicate')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="71" height="48" viewBox="0 0 71 48" fill="none">
                        <rect width="70.6667" height="48" rx="10" fill="#D6E5FF" />
                        <path d="M39.5 28L44.5 33M44.5 28L39.5 33M38.5 15.2908C39.9659 15.8841 41 17.3213 41 19C41 20.6787 39.9659 22.1159 38.5 22.7092M35 27H31C29.1362 27 28.2044 27 27.4693 27.3045C26.4892 27.7105 25.7105 28.4892 25.3045 29.4693C25 30.2044 25 31.1362 25 33M36.5 19C36.5 21.2091 34.7091 23 32.5 23C30.2909 23 28.5 21.2091 28.5 19C28.5 16.7909 30.2909 15 32.5 15C34.7091 15 36.5 16.7909 36.5 19Z" stroke="#575757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <div>
                        <div className='d-flex align-items-center gap-1 mb-1'>
                          <div className='title'>Remove Duplicates</div>
                          <div className='recommended'>Recommended</div>
                        </div>
                        <div className='description'>
                          Only import unique records, ignoring duplicate records
                        </div>
                      </div>
                    </div>
                    <div className={`remove-duplicate ${duplicate == 'leave_duplicate' && 'active'}`} onClick={() => changeDuplicate('leave_duplicate')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="71" height="48" viewBox="0 0 71 48" fill="none">
                        <rect width="70.6667" height="48" rx="10" fill="#EAEAEA" />
                        <path d="M39 30L41 32L45 28M35 27H31C29.1362 27 28.2044 27 27.4693 27.3045C26.4892 27.7105 25.7105 28.4892 25.3045 29.4693C25 30.2044 25 31.1362 25 33M38.5 15.2908C39.9659 15.8841 41 17.3213 41 19C41 20.6787 39.9659 22.1159 38.5 22.7092M36.5 19C36.5 21.2091 34.7091 23 32.5 23C30.2909 23 28.5 21.2091 28.5 19C28.5 16.7909 30.2909 15 32.5 15C34.7091 15 36.5 16.7909 36.5 19Z" stroke="#575757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <div>
                        <div className='title mb-1'>Leave Duplicates</div>
                        <div className='description'>
                          Import all records, including duplicate records
                        </div>
                      </div>
                    </div>
                    <div className='d-flex gap-1 align-items-center'>
                      {/* <label className="custom-checkbox checkbox me-0 pe-0">
                        <input type="checkbox" defaultChecked name="remove_duplicate" onChange={handleCheckboxChange} />
                        <span className="checkmark"></span>
                      </label> */}
                      <span>
                        {duplicate !== 'remove_duplicate' ?
                          'Import all leads regardless of existing records':
                          'Check for and remove existing leads in this campaign'
                        }
                      </span>
                    </div>
                  </div>
                )
                : stepToShow == 4 ?
                  (
                    <>
                      <div>Generate {duplicate == 'remove_duplicate' ? rowsData?.unique_pages : rowsData?.total_pages} Lead Pages</div>
                      <button type="button" className="credits-info" disabled={stepToShow == 4 && isGenerateDisabled ? true : false} onClick={handleButtonClick}>
                        <div className="d-flex align-items-center gap-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                            <rect x="1" y="0.5" width="21" height="21" rx="6.5" fill="#FFF7DD" />
                            <rect x="1" y="0.5" width="21" height="21" rx="6.5" stroke="#FFF3C7" />
                            <path d="M13.4689 12.9689C15.1802 12.7398 16.5 11.274 16.5 9.5C16.5 7.567 14.933 6 13 6C11.226 6 9.76024 7.31983 9.53113 9.03113M9.25 11.5L10 11V13.75M9.25 13.75H10.75M13.5 12.5C13.5 14.433 11.933 16 10 16C8.067 16 6.5 14.433 6.5 12.5C6.5 10.567 8.067 9 10 9C11.933 9 13.5 10.567 13.5 12.5Z" stroke="#FFCE22" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          {/* <span>Import {formValues?.remove_duplicate ? rowsData?.unique_pages : rowsData?.total_pages} leads and generate {formValues?.remove_duplicate ? rowsData?.unique_pages : rowsData?.total_pages} pages</span> */}
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <span>{creditsDataReducer?.total_credits} Credits Remaining</span>
                          <NavLink to={`${basePath}/settings`} className="p-0 blue-text-navigate">
                            Manage Plan
                            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                              <path d="M0.5 6.5L6.5 0.5M6.5 0.5H2.5M6.5 0.5V4.5" stroke="#1188FF" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </NavLink>
                        </div>
                        <div className='d-flex align-items-center gap-1'>
                          <input type="checkbox" id="download_csv" disabled={stepToShow == 4 && isGenerateDisabled ? true : false} className='ui-checkbox me-0' defaultChecked name="download_csv" onChange={handleInputChange}/>
                          <label htmlFor='download_csv'>
                            Download as CSV file
                          </label>
                        </div>
                      </button>
                      {
                        rowsData?.leads_limit > 0 &&
                        <>
                        <div className='mt-20px'>Import {duplicate == 'remove_duplicate' ? rowsData?.unique_pages : rowsData?.total_pages} Leads</div>
                        <button disabled={duplicate == 'remove_duplicate' && (rowsData?.unique_pages == 0)} className="credits-info" onClick={() => exportCSV(0)}>
                          <div className="d-flex align-items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                              <rect x="1" y="0.5" width="21" height="21" rx="6.5" fill="#FFF7DD" />
                              <rect x="1" y="0.5" width="21" height="21" rx="6.5" stroke="#FFF3C7" />
                              <path d="M13.4689 12.9689C15.1802 12.7398 16.5 11.274 16.5 9.5C16.5 7.567 14.933 6 13 6C11.226 6 9.76024 7.31983 9.53113 9.03113M9.25 11.5L10 11V13.75M9.25 13.75H10.75M13.5 12.5C13.5 14.433 11.933 16 10 16C8.067 16 6.5 14.433 6.5 12.5C6.5 10.567 8.067 9 10 9C11.933 9 13.5 10.567 13.5 12.5Z" stroke="#FFCE22" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                          <div>This action will import {duplicate == 'remove_duplicate' ? rowsData?.unique_pages : rowsData?.total_pages} leads to your workspace. You have {rowsData?.leads_limit} leads remaining on your plan. You can export landing pages for your leads later in the "leads" section.</div>
                            {/* <NavLink to={`${basePath}/settings`} className="p-0 blue-text-navigate">
                              Manage Plan
                              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                                <path d="M0.5 6.5L6.5 0.5M6.5 0.5H2.5M6.5 0.5V4.5" stroke="#1188FF" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            </NavLink> */}
                          </div>
                        </button>
                        </>
                      }
                    </>
                  )
                  : <>
                    <div className="form-group w-100 p-0 mt-3">
                      <div className="generate-download">
                        <div>
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                            <rect x="0.5" y="0.5" width="21" height="21" rx="6.5" fill="#FFF7DD" />
                            <rect x="0.5" y="0.5" width="21" height="21" rx="6.5" stroke="#FFF3C7" />
                            <path d="M7.25 16V13.5M7.25 8.5V6M6 7.25H8.5M6 14.75H8.5M11.5 6.5L10.6329 8.75443C10.4919 9.12105 10.4214 9.30435 10.3118 9.45854C10.2146 9.5952 10.0952 9.71459 9.95854 9.81176C9.80435 9.9214 9.62105 9.99191 9.25443 10.1329L7 11L9.25443 11.8671C9.62105 12.0081 9.80435 12.0786 9.95854 12.1882C10.0952 12.2854 10.2146 12.4048 10.3118 12.5415C10.4214 12.6956 10.4919 12.879 10.6329 13.2456L11.5 15.5L12.3671 13.2456C12.5081 12.879 12.5786 12.6956 12.6882 12.5415C12.7854 12.4048 12.9048 12.2854 13.0415 12.1882C13.1956 12.0786 13.379 12.0081 13.7456 11.8671L16 11L13.7456 10.1329C13.379 9.99191 13.1956 9.9214 13.0415 9.81176C12.9048 9.71459 12.7854 9.5952 12.6882 9.45854C12.5786 9.30435 12.5081 9.12105 12.3671 8.75443L11.5 6.5Z" stroke="#FFCE22" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className="ms-1 align-middle">Your export is processing</span>
                        </div>
                        <div>If you stay on this page, you’ll automatically be <br /> redirected to the leads page. We’ll send you an email <br /> with a link to view your export once complete.</div>
                      </div>
                    </div>
                  </>
          }
        </div>

        <div className='generate-footer'>
          <>
            <div>
              {uploadedFile ? uploadedFile[0]?.name : null}
            </div>
            {((importType == 'csv' && uploadedFile?.length > 0) || (importType == 'manual' )) &&
              <div class="d-flex justify-content-end submit-buttons-fixed gap-2" >
                {
                  stepToShow !== 5 &&
                  <button onClick={backStep} type="button" class="project-white-button">
                    Back
                  </button>
                }
                {stepToShow !== 4 &&
                <button type="button" onClick={continueBtn} name="submit" class="project-blue-btn">
                  <span class="productlabel2">{stepToShow == 5 ? 'Upload New' : 'Continue'}</span>
                </button>
                }
              </div>
            }
          </>
        </div>
      </div>
      <ExportHistory {...props} params={params} loading={loading} setloading={setloading} filter={filter} setfilter={setfilter} getExportHistory={getExportHistory} exportHistory={exportHistory} setExportHistory={setExportHistory} />
      {exportToSteps?.step == 1 && <ExportToModal show={true} exportToSteps={exportToSteps} setShow={setExportToSteps} exportCSV={exportCSV}/>}
      {exportToSteps?.step == 2 && exportToSteps?.export_to !== 'csv' && <ExportFormModal title={'Send to Google Sheets'} handleSave={exportCSV} show={true} exportToSteps={exportToSteps} setExportToSteps={setExportToSteps} error={error} buttonText={'Submit'} />
      }
    </section>
  )
}

export default Generate